export const CLOTHING_ORDER: Record<string, number> = {
  XXS: 1,
  XS: 2,
  S: 3,
  M: 4,
  L: 5,
  XL: 6,
  XXL: 7,
  XXXL: 8,
  'ONE SIZE': 1000,
  'NO SIZE': 1001,
}
